import React from 'react';
import { Typography, Row, Col, Button, Input, Radio, Form, Grid, Divider } from 'antd';
import '../../Styles/Opportunities.css'; 

const { Title, Paragraph } = Typography;
const { TextArea } = Input;
const { useBreakpoint } = Grid;


const CollaborateWithUs = () => {
  const screens = useBreakpoint();

  const [form] = Form.useForm();
  const onFinish = (values) => {
    console.log('Form values:', values);
  };

  return (
    <div className="collaborate-container">
      <Row gutter={[48, 16]}>
        <Col xs={24} md={12}>
          <Title style={{
            fontSize: screens.xs ? '24px' : screens.sm ? '48px' : screens.lg ? '48px' : '48px',
            fontWeight: 'bold', textAlign: "start",color:"black"
          }} className="collaborate-title">Collaborate With Us</Title>
          <Divider className="ncgsa-divider" />
          <Paragraph style={{
            fontSize: screens.xs ? '14px' : screens.sm ? '20px' : screens.lg ? '125px' : '25px',
            lineHeight: screens.xs ? '1.5' : '1.8',
            textAlign: 'justify',
            color: 'black' 
          }} className="collaborate-text">
            At NCGSA, every collaboration within the space sector is important for us. We believe it is only through cooperation, coordination, and collaboration that an increasing number of like-minded people get a chance to interact and benefit from each other on an organizational level.
          </Paragraph>
          <Paragraph style={{
            fontSize: screens.xs ? '14px' : screens.sm ? '20px' : screens.lg ? '125px' : '25px',
            lineHeight: screens.xs ? '1.5' : '1.8',
            textAlign: 'justify',
            color: 'black' 
          }} className="collaborate-text">
            If you as an individual, company, or organization can foresee a mutually beneficial collaboration for the betterment of research and accomplishments in the space sector, feel free to contact us using the links/emails/contact numbers provided.
          </Paragraph>
        </Col>
        <Col xs={24} md={12}>
          <Form form={form} layout="vertical" onFinish={onFinish}>
            <Form.Item
              name="collaborationType"
              label="Type of Collaboration *"
              
              rules={[{ required: true, message: 'Please select a type of collaboration' }]}
            >
              <Radio.Group>
                <Radio value="individual">Individual Researcher</Radio>
                <Radio value="team">Team of Researchers</Radio>
                <Radio value="organization">Institute or Organization</Radio>
              </Radio.Group>
            </Form.Item>

            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item
                  name="firstName"
                  rules={[{ required: true, message: 'Please input your first name' }]}
                >
                  <Input placeholder="First name *" />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="lastName"
                  rules={[{ required: true, message: 'Please input your last name' }]}
                >
                  <Input placeholder="Last name *" />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item
              name="email"
              rules={[
                { required: true, message: 'Please input your email' },
                { type: 'email', message: 'Please enter a valid email address' },
              ]}
            >
              <Input placeholder="Your email *" />
            </Form.Item>
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item
                  name="researchArea"
                  label="Research Area *"
                  rules={[{ required: true, message: 'Please provide your research area' }]}
                >
                  <TextArea rows={3} placeholder="Research Area? *" />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="expectations"
                  label="Your Expectations from NCGSA? *"
                  rules={[{ required: true, message: 'Please provide your expectations' }]}
                >
                  <TextArea rows={3} placeholder="Your Expectations from NCGSA? *" />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item>
              <Button type="primary" htmlType="submit" className="submit-button">
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default CollaborateWithUs;
